import './Landing.sass';
import { useMemo, useState, useRef, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import selectArrow from '../assets/select-arrow.svg';
// import imagePreview from '../assets/image-preview.svg';
import Pagination from '../components/Pagination';
import { chunk, map } from 'underscore';
import { useWindowSize } from 'react-use';
import useAssets from '../hooks/useAssetsBatch';
import useCollection from '../hooks/useCollection';
import useCheckVideo from '../hooks/useCheckVideo';
import textareaToHtml from '../tools/textareaToHtml';
import useModal from '../hooks/useModal';
import { useTranslation } from 'react-i18next';
const _ = require('lodash');

const getVideoId = (url) => {
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;
	const m = regex.exec(url);
	if (m !== null) {
		return m[3];
	}
	return null;
}

const checkYouTubeVideo = (urlToValidate) => {
	// 正規式
	const regex = /^https:\/\/www\.(youtube|youtube-nocookie)\.com\/(embed\/|watch\?v=)([a-zA-Z0-9_-]{11})(\?si=[a-zA-Z0-9_-]+)?$/;

	// 驗證
	if (regex.test(urlToValidate)) {
		return true;
	}
	
	return false;
};

const Nft = ({ nft, owners }) => {
	const { t, i18n } = useTranslation();
	const { sendModal } = useModal();
	const { isVideo, mediaType, checkForVideo } = useCheckVideo();
	const loggedAddress = localStorage.getItem('walletAddress');

	useEffect(() => {
		if (nft[0].uri) checkForVideo(nft[0].uri);
	}, [nft[0].uri, checkForVideo]);

	let navLink = nft.length > 1 ? `/collection/${ nft[0].collectionId }` : `/collection/${ nft[0].collectionId }/${ nft[0].id }`, 
		// subscribeOnly = !nft[0].collectionInfo.subscribeOnly || [nft[0].creatorInfo.walletAddress, nft[0].ownerInfo.walletAddress].includes(loggedAddress), 
		subscribeOnly = !nft[0].collectionInfo.subscribeOnly || owners.includes(loggedAddress),
		coverImage = subscribeOnly ? nft[0].uri : nft[0].collectionInfo.uri, 
		nftName = nft[0].fullName;

	let avgValuePrice = map(nft, (v) => v.valuePrice);
	avgValuePrice = avgValuePrice.reduce((memo, num) => memo + num, 0) / avgValuePrice.length || 1;

	const content = <>
	<div className='zoom-wrapper'>
		<div className='cover' style={{ backgroundImage: `url(${coverImage})` }} onContextMenu={(e) => e.preventDefault()}>
			{/* { isVideo ? 'video or audio' : 'image'} */}
			{subscribeOnly ? (
				isVideo ? (
					mediaType === 'audio' ? (
						<div
								className="image-wrap"
								style={{
									backgroundImage: `url(${nft[0].collectionInfo.uri})`,
									height: 315,
									width: '100%',
									backgroundSize: 'cover',
									backgroundPosition: 'center',
									marginBottom: 8
								}}
						/>
					) : (
						<video src={ `${nft[0].uri.replace(/\s/g, '')}#t=0.15`} preload='metadata' autoPlay muted controlsList="nodownload"></video>
					)
				) : (checkYouTubeVideo(nft[0].uri.replace(/\s/g, '')) ? (
					// <iframe 
					// 	className='image-wrap'
					// 	width="560" 
					// 	height="315" 
					// 	src={`https://www.youtube.com/embed/${getVideoId(nft[0].uri.replace(/\s/g, ''))}`}
					// 	title="YouTube video player" 
					// 	frameBorder="0" 
					// 	allow="accelerometer; encrypted-media; gyroscope;" 
					// 	allowFullScreen>
					// </iframe>
					<img style={{ transform: 'scale(1.2)' }} src={`https://img.youtube.com/vi/${getVideoId(nft[0].uri.replace(/\s/g, ''))}/0.jpg`} alt={`${nftName}_screenplay`}></img>
				) : null)
			) : (<span>僅對擁有者開放</span>)}
		</div>
	</div>
	<div className='info-wrap'>
		<div className='row margin'>
			<div className='nft-name'> {nftName}</div>
		</div>
		<div className='row flex-between'>
			<div className='price'>
				{Math.round(avgValuePrice * 100) / 100} P
			</div>
			<div className='stock'>
				{t('landing.third_section_card_listed_text_items')} <b>{ nft.length > 1 ? (
					`${ nft.length }/${ nft[0].parentAmount }`
				) : nft.length}</b>
			</div>
		</div>
	</div>
	</>

	return (
		<div className='item'>
			<div className='content'>
				{ nft.length > 1 ? (
					<div className="listings" onClick={(e) => { e.stopPropagation(); sendModal(`${ nftName }_Listings`, t('landing.third_section_card_listed_list_title'), nft); }}>{ content }</div>) : (
					<Link to={ navLink }>{ content }</Link>
				) }
			</div>
		</div>
	)
}

const Collection = () => {

	const { t, i18n } = useTranslation();
	const { collectionId } = useParams();
	const { collection, getCollection } = useCollection();
	const { assetsBatch: assets, getAssetsBatch: getAssets } = useAssets();
	const [sort, setSort] = useState('createdAtAscending');
	const [currentPage, setCurrentPage] = useState(1);
	const { width } = useWindowSize();
	const nftSection = useRef();
	const [nftSectionTop, setNftSectionTop] = useState(0);
	const [sortBy, setSortBy] = useState('createdAt');
	const [sortDirection, setSortDirection] = useState('ASC');
	const dateFormatter = new Intl.DateTimeFormat(i18n.language, { year: 'numeric', month: 'long', day: 'numeric' });

	useEffect(() => {
		if (collectionId && getCollection) getCollection(collectionId);
	}, [collectionId, getCollection]);

	useEffect(() => {
		getAssets({ sortBy, sortDirection, collectionId, groupBy: 1 });
	}, [sortBy, sortDirection, getAssets, collectionId]);

	const itemsPerPage = useMemo(() => {
		if (width >= 768) return 12;
		return 6;
	}, [width]);

	const pages = useMemo(() => {
		return chunk(assets, itemsPerPage);
	}, [itemsPerPage, assets]);

	const currentPageList = useMemo(() => {
		if (pages.length) return pages[currentPage - 1];
		return [];
	}, [currentPage, pages]);

	useEffect(() => {
		let offset;

		if (width > 1366) offset = 75;
		if (width <= 1366 && width >= 768) offset = Math.round(75 / 1366 * width);
		if (width < 768) offset = Math.round(50 / 375 * width);

		setNftSectionTop(nftSection?.current?.offsetTop - offset);
	}, [nftSection?.current?.offsetTop, width]);

	useEffect(() => {

		switch (sort) {
			case 'createdAtAscending':
				setSortBy('createdAt');
				setSortDirection('ASC');
				break;

			case 'createdAtDescending':
				setSortBy('createdAt');
				setSortDirection('DESC');
				break;

			case 'priceAscending':
				setSortBy('valuePrice');
				setSortDirection('ASC');
				break;

			case 'priceDescending':
				setSortBy('valuePrice');
				setSortDirection('DESC');
				break;
		}
		
	}, [sort]);

	const uniq_owners = _.uniq(_.map(assets.flat(Infinity), 'ownerInfo.walletAddress'));
	const descriptions = {
		[t('collection.unique_items')]: collection.id ? collection.uniqueTokens.length : 0, 
		[t('collection.total_items')]: collection.id ? `${ collection.onSellAmount }/${ collection.totalCount }` : '', 
		[t('collection.created')]: collection.id ? dateFormatter.format(new Date(collection.createdAt)) : ''
	};

	return (
		<div id='Collection'>
			<section className='spotlight'>
				<div className='slider-wrap'>
					<div className='image' style={{ backgroundImage: `url(${collection.uri})` }}></div>
				</div>

				<div className='intro v-center'>
					<h1>{collection.fullName}</h1>
					<div className='description'>{t('collection.by')} <b>{ collection.id ? `${collection.creatorAddress.slice(2, 8).toLocaleUpperCase()}`: '' }</b></div>
					{/* <div className='description'>{ collection.id ? `項目總數：${ collection.onSellAmount }/${ collection.totalCount }  ·  建立日期：${ dateFormatter.format(new Date(collection.createdAt)) }` : ''}</div> */}
					<div className='description-wrapper'>
						{ Object.entries(descriptions).map(([k, v], i) => (
						<div key={i} className='description'>
							{ k }：{ v }
						</div>)) }
					</div>
					<p className='description' style={{"overflow-y": "auto", "max-height": "350px"}} dangerouslySetInnerHTML={{ __html: textareaToHtml(collection.description) }}></p>
				</div>
			</section>

			<div className='monetization-block'>Google ad</div>

			<section className='nfts' ref={nftSection}>
				<h2>{t('landing.third_section_title')}</h2>

				<div className='controls'>
					<div className='select-wrap'>
						<select defaultValue={sort} style={{ backgroundImage: `url(${selectArrow})` }} onChange={(e) => { setSort(e.target.value) }}>
							<option value='createdAtDescending'>{t('landing.third_section_select_sort_new_old')}</option>
							<option value='createdAtAscending'>{t('landing.third_section_select_sort_old_new')}</option>
							<option value='priceDescending'>{t('landing.third_section_select_sort_high_low')}</option>
							<option value='priceAscending'>{t('landing.third_section_select_sort_low_high')}</option>
						</select>
					</div>
				</div>

				<div className='list-wrap'>
					{currentPageList?.map((nft, index) => {
						nft = _.filter(nft, { 'available': true });
						return (
							nft.length > 0 ? <Nft key={ `NFT_${index}`} nft={nft} owners={uniq_owners} /> : null
						)
					})}
				</div>

				<Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pages.length} top={nftSectionTop} />
			</section>

			<div className='monetization-block'>Google ad</div>
		</div>
	);
};

export default Collection;
